import { action, observable } from 'mobx'
// Request
import { ScanPdfRequest } from '../requests/ScanPdfRequest'

class ScanPdfStore {
  @observable ocrResult = null

  @action recognizeText = file => {
    return new Promise((resolve, reject) => {
      ScanPdfRequest.recognizeText(file)
        .then(response => {
          this.ocrResult = response.data
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }

  @action getOcrStatus = () => {
    return new Promise((resolve, reject) => {
      ScanPdfRequest.getOcrStatus()
        .then(response => {
          this.ocrResult = response.data
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }

  @action clearOcrResult = () => {
    this.ocrResult = null
  }
}

export default new ScanPdfStore()
